<i2g-job-detail-list-item
  *ngFor="let item of listItems"
  [label]="item.label"
  [value]="item.value"
  [link]="item.link"
  class="list-item"
></i2g-job-detail-list-item>
